import { MenuAuthorityIds } from '@/enums/common.enum';

export const getMenuName = (menuId?: MenuAuthorityIds) => {
  if (!menuId) {
    return '';
  }

  switch (menuId) {
    case MenuAuthorityIds.GROUP_HOME:
      return 'studio.gnb.group_myinfo.my_group.detailed_group_per_home';
    case MenuAuthorityIds.DASHBOARD_COMPONENT_DISPLAY:
      return 'studio.member_manage.per_by_menu.grp_dashboard_component_view';
    case MenuAuthorityIds.PROJECT_PRODUCT:
      return 'studio.gnb.group_myinfo.my_group.detailed_group_per_prj_prod';
    case MenuAuthorityIds.COLLECTION:
      return 'studio.gnb.group_myinfo.my_group.detailed_group_per_collection';
    case MenuAuthorityIds.STORE_COMMUNITY:
      return 'studio.gnb.group_myinfo.my_group.detailed_group_per_store_comm';
    case MenuAuthorityIds.MEMBER_MANAGEMENT:
      return 'studio.gnb.group_myinfo.my_group.detailed_group_per_mem_mngmt';
    case MenuAuthorityIds.BILL_SETTLEMENT:
      return 'studio.gnb.group_myinfo.my_group.detailed_group_per_bill_settlement';
    case MenuAuthorityIds.STATISTICS:
      return 'studio.gnb.group_myinfo.my_group.detailed_group_per_statistics';
    case MenuAuthorityIds.BIMS_BANK_SETTING:
      return 'studio.gnb.group_myinfo.my_group.detailed_group_per_biz_bank_info';
    default:
      return menuId;
  }
};
